import { render, staticRenderFns } from "./costHelp.vue?vue&type=template&id=40c3efd9&"
import script from "./costHelp.vue?vue&type=script&lang=js&"
export * from "./costHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c3efd9')) {
      api.createRecord('40c3efd9', component.options)
    } else {
      api.reload('40c3efd9', component.options)
    }
    module.hot.accept("./costHelp.vue?vue&type=template&id=40c3efd9&", function () {
      api.rerender('40c3efd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B2HbSvxlCXzR/JS/costHelp.vue"
export default component.exports